import React from "react";
import { Switch, Route } from "react-router";
import DocumentViewer from "../../components/DocumentViewer";
import "./index.scss";

const CreditsLayout = () => {
  return (
    <div className="creditsLayout">
      <Switch>
        <Route exact path="/privacy-policy">
          <DocumentViewer documentName={"privacy"} />
        </Route>
        <Route exact path="/terms-of-use">
          <DocumentViewer documentName={"termsOfUse"} />
        </Route>
        {/*<Route exact path="/e-contract">*/}
        {/*  <DocumentViewer documentName={"eContract"} />*/}
        {/*</Route>*/}
      </Switch>
    </div>
  );
};

export default CreditsLayout;
